import { useMemo } from 'react';
import { useAppDispatch } from '@/app/store/store';
import { useGetMenuQuery } from '../../infra/adapters/menuApiSlice';
import { menuBuild } from '../../config/menu.build';
import type { MenuItem } from '../../domain/models/MenuItem';

// Re-export domain types for convenience
export type { MenuItem, MenuSubCategory, MenuCategory } from '../../domain/models/MenuItem';

/**
 * Shared Menu Feature - Presentation Hook
 * Reads from RTK Query cache synchronously so SSR and first client render have menu data
 * (cache is seeded by ReduxProvider from SSR/window). No async fetch on mount.
 */
export function useMenu() {
  const dispatch = useAppDispatch();
  const { data, isLoading, error } = useGetMenuQuery(undefined, {
    refetchOnMountOrArgChange: false,
  });

  // getMenu cache holds MenuApiResponse { hamburger, desktop }; hamburger is used for the hamburger menu
  const menuData: MenuItem[] = data?.hamburger ?? [];

  const menuService = useMemo(() => {
    const { service } = menuBuild(dispatch);
    return service;
  }, [dispatch]);

  return {
    menuData,
    isLoading,
    error: error ?? null,
    menuService,
  };
}


